module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-cascader', {
    attrs: {
      "placeholder": "根据地区筛选",
      "options": _vm.regions,
      "filterable": "",
      "props": {
        checkStrictly: true
      }
    },
    on: {
      "change": _vm.RegionChangeSearch
    },
    model: {
      value: (_vm.selected_values),
      callback: function($$v) {
        _vm.selected_values = $$v
      },
      expression: "selected_values"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73ab4596", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ab4596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/regionSelect/index.vue
// module id = 2825
// module chunks = 0